import React from 'react'
import KycButton from '../Button/Button'
import '../../kyc/kycStyle.css'
const NewAndCloseButtons = ({
  handleAction,
  handleClose,
  showAction = true,
  showClose = true,
}) => {
  return (
    <div
      className="footer-btns mt-2"
      style={{ display: 'flex', justifyContent: 'left' }}
    >
      {showAction && (
        <KycButton
          onClick={handleAction}
          variant={'outline-primary'}
          children={'New Search'}
          size="lg"
        />
      )}
      {showClose && (
        <KycButton
          className="m-l-10"
          onClick={() => handleClose(false)}
          variant={'outline-primary'}
          children={'Close'}
          size="lg"
        />
      )}
    </div>
  )
}
export default NewAndCloseButtons
